import React from "react";
import { Card, Col, Row } from "antd";

import NgomaLogo from "../../assets/logos/ngoma-logo.png";
import DailyVotingList from "./charts/dailyVotingList";
import { Typography, Space } from "antd";
import { DashboardOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

function Dashboard() {
  return (
    <div style={{ padding: "15px", background: "#f3f4f6", minHeight: "100vh" }}>
      <div style={{ marginBottom: "32px" }}>
        <Space direction="vertical" size={4}>
          <Title level={3} style={{ margin: 0, color: "#111827", fontWeight: 700 }}>
            <DashboardOutlined style={{ color: "#1890ff", marginRight: "12px" }} />
            Painel Geral
          </Title>
          <Text type="secondary" style={{ fontSize: "15px" }}>
            Visão geral das estatísticas e desempenho das edições em tempo real.
          </Text>
        </Space>
      </div>

      <Row gutter={[24, 24]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <DailyVotingList />
        </Col>
      </Row>
    </div>
  );
}

export default Dashboard;